import React from "react";
import { useGetAuth } from "../hooks/useGetAuthHook";
import { User } from "../types/types";
import { useParams } from "react-router-dom";
import { formatDate } from "../utils/helpers";
import { Mail, Phone, Calendar } from "lucide-react";
import ProfileLayout from "../components/ProfileLayout";

const SingleAlumni = () => {
  const { id } = useParams<{ id: string }>();

  const { data: user, isLoading, error } = useGetAuth<User>(`/users/${id}`);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-stone-50">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-zinc-200 border-t-orange-600 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-zinc-600">Loading alumni profile...</p>
        </div>
      </div>
    );
  }

  if (error || !user) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-stone-50">
        <div className="text-center text-red-600">
          <p className="text-lg font-semibold mb-2">
            Error loading alumni profile
          </p>
          <p className="text-sm text-zinc-600">
            {error?.message || "No alumni data found."}
          </p>
        </div>
      </div>
    );
  }

  const infoCards = [
    { icon: Mail, label: "Email", value: user.email },
    { icon: Phone, label: "Phone", value: user.phone },
    { icon: Calendar, label: "Birthday", value: formatDate(user.dob) },
    {
      icon: undefined,
      label: "Gender",
      value: user.gender === "M" ? "Male" : "Female",
      customIcon: (
        <div className="w-6 h-6 rounded-full bg-orange-600 flex items-center justify-center text-white text-xs font-bold">
          {user.gender}
        </div>
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-stone-50">
      <ProfileLayout user={user} infoCards={infoCards} isEditable={false} />
    </div>
  );
};

export default SingleAlumni;
